import { t } from '@lingui/macro'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import { Button } from '@/@bothrs-ui/web/components/primitives/button/Button'
import { H2, H4 } from '@/@bothrs-ui/web/components/typography/Heading'
import { useCareProgramById } from '@/modules/care/hooks/useCarePrograms'
import { AnimatedLoader } from '@/modules/shared/components/loader/Loader'
import { openUrl } from '@/utils/external-resources'
import { ContentItemDetailLayout } from '../../components/ContentItemDetailLayout'
import { RichText } from '../../components/RichText'
import { serializeHTML } from '../../components/RichText/serialize'

export const ProgramPreviewPage = () => {
  const { id } = useParams()
  const { data: careProgram, error, isLoading } = useCareProgramById(id)

  useEffect(() => {
    const linkedUrl = careProgram?.linkedEntry?.[0]?.url
    if (linkedUrl) {
      openUrl(linkedUrl)
    }
  }, [careProgram?.linkedEntry])

  if (isLoading) {
    return (
      <Container>
        <AnimatedLoader />
      </Container>
    )
  }

  if (error) {
    return (
      <ErrorContainer>
        <H2>Fout bij het laden het programma</H2>
      </ErrorContainer>
    )
  }

  return (
    <Container>
      <ContentItemDetailLayout
        loading={isLoading}
        onGoBack={undefined}
        preview={true}
        bannerUrl={careProgram?.featuredImage?.url}
        bannerContent={
          <StBannerContent>
            <H2>{careProgram?.title}</H2>
            <H4 style={{ fontWeight: 500 }}>{careProgram?.description && serializeHTML(careProgram?.description)}</H4>
          </StBannerContent>
        }
        footer={
          <Button variant='Primary' onClick={() => {}}>
            {t({
              id: 'careProgramDetail.enrollButton',
              message: 'Ik heb interesse',
            })}
          </Button>
        }
      >
        <StContentContainer>
          {careProgram?.contentBlocks ? <RichText contentBlocks={careProgram.contentBlocks} /> : null}
        </StContentContainer>
      </ContentItemDetailLayout>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: auto;
  max-width: 800px;
`

const StBannerContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.UI.SpacingPx.Space3};

  padding: ${({ theme }) => theme.UI.SpacingPx.Space6};

  * {
    color: ${({ theme }) => theme.Colors.Neutrals.Lightest};
    margin: 0;
  }

  p {
    font-weight: 500;
  }
`

const StContentContainer = styled.div`
  flex: 1;
  overflow-y: auto;

  padding-top: ${({ theme }) => theme.UI.SpacingPx.Space4};
`
